/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["select[_ngcontent-%COMP%]{z-index:99}a[_ngcontent-%COMP%]{font-size:.8em}a.active[_ngcontent-%COMP%]{background-color:#d3d3d3}"];
export { styles as styles };
